/**
 * Interface 메소드 호출을 위하여 기기 구분을 위해 User Agent를 추출합니다.
 * Android: OCTO-KSS-Android/{AppVersion}
 * iOS: OCTO-KSS-iOS/{AppVersion}
 * 이외에는 모두 Web으로 처리합니다.
 */
export const getInterfaceUserAgentType = (): "Web" | "iOS" | "Android" => {
  const userAgent = navigator.userAgent;

  // User-Agent가 지정된 결과와 일치하는 값이 있고, Interface 메소드가 호출 가능해야 각각의 앱으로 인식
  if (userAgent.match(/OCTO-KSS-Android/i) && window.Android) return "Android";
  else if (userAgent.match(/OCTO-KSS-iOS/i) && window.webkit) return "iOS";
  else return "Web";
};

/**
 * 로그인 완료 Interface 함수 호출
 */
export const handleAppLoginSuccess = () => {
  switch (getInterfaceUserAgentType()) {
    case "Android":
      if (window.Android) window.Android.loginSuccess();
      break;
    case "iOS":
      if (window.webkit)
        window.webkit.messageHandlers.loginSuccess.postMessage("");
      break;
    default:
      break;
  }
};

/**
 * 다운로드 Interface 함수 호출
 */
export const handleDownload = (fileUrl: string) => {
  switch (getInterfaceUserAgentType()) {
    case "Android":
      if (window.Android) window.Android.download(fileUrl);
      break;
    case "iOS":
      if (window.webkit)
        window.webkit.messageHandlers.download.postMessage(fileUrl);
      break;
    default:
      break;
  }
};

/**
 * 로그아웃 Interface 함수 호출
 */
export const handleLogout = () => {
  switch (getInterfaceUserAgentType()) {
    case "Android":
      if (window.Android) window.Android.logout();
      break;
    case "iOS":
      if (window.webkit) window.webkit.messageHandlers.logout.postMessage("");
      break;
    default:
      break;
  }
};
